// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"8bc93bc2","977":"c9950f6d"}[chunkId] + ".chunk.js";
};